import { Component } from '@angular/core';

@Component({
  selector: 'app-confirm-document-inscription-dialog',
  templateUrl: './confirm-document-inscription-dialog.component.html',
  styleUrls: ['./confirm-document-inscription-dialog.component.scss']
})
export class ConfirmDocumentInscriptionDialogComponent {

}
